/* eslint-disable */
/**
 * 工具库
 * 引入方式 import utils from '@/deps/utils';
 * @module utils
 */

/**
 * 获取地址对应查询参数值
 * @param {String} key - Query key
 * @return {String} Value
 */
export const getUrlQueryValue = function (key) {
    const search = location.search;
    var value;
    if (search) {
      search.slice(1).split('&').some((fragment) => {
        const arr = fragment.split('=');
        if (arr[0] === key) {
          value = arr[1];
          return true;
        }
      });
    }
    return value;
  };
  
  /**
   * 获取平台名（内部根据platformName参数值判定）
   * @return {String} 平台名
   */
  export const getPlatformName = function () {
    const platformName = getUrlQueryValue('platformName') || 'pc'; // 默认pc平台
    return platformName;
  };
  
  /**
   * 获取页面title（内部根据title query param返回）
   * @return {Stirng} 页面title
   */
  export const getDocumentTitle = function () {
    const title = getUrlQueryValue('title') || ''; // Document title
    return title;
  };
  
  /**
   * 设置Document title
   * @param {String} title Document title
   */
  export const setDocumentTitle = function (title) {
    document.getElementsByTagName('title')[0].innerHTML = title;
    window.AlipayJSBridge && window.AlipayJSBridge.call('setTitle', { // 支付宝修改title的方式
      title: title
    });
  };
  
  /**
   * 根据请求参数或者访问地址判断是否处于develop状态
   * 开发环境包括127.0.0.1/localhost/192.168.x.x（不包括192.168.49.61）
   * @return {Boolean} true/false
   */
  export const isDevelop = function () {
    const debugValue = getUrlQueryValue('develop') || '';
    if (debugValue !== '') {
      return !!(debugValue / 1);
    } else { // 根据访问地址判断
      const hostname = location.hostname;
      // 本地或者非61的局域网段都认为是开发模式
      if (hostname === 'localhost' ||
        hostname === '127.0.0.1' ||
        (hostname.slice(0, 7) === '192.168' && hostname !== '192.168.49.61')
      ) {
        return true;
      } else {
        return false;
      }
    }
  };
  
  /**
   * 获取当前代理数据请求地址前缀
   * @return {String} ?proxy="返回值"
   */
  export const getProxyPrefix = function () {
    const prefix = getUrlQueryValue('proxy') || 'mock'; // 代理前缀
    return prefix;
  };

  /**
   * sessionStorage操作
   */
  export const sessionStorage = window.sessionStorage
  
  /**
   * localStorage操作
   */
  export const localStorage = window.localStorage
  
  /**
   * 生成唯一id
   * @return {String} uuid
   */
  export const generateID = function () {
    return 'x' + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
  };
  
  /**
   * 自定义log屏幕打印
   * @param {String} message - log message
   * @param {String} [pattern = 'append'] - 信息显示方式：append（追加到上一条后面）; clear（先清屏）
   */
  export const log = function (message, pattern) {
    pattern = pattern || 'append';
    let logDom = document.getElementById('app-log');
    let bodyDom = null;
    let closeHandlerDom = null;
    if (!logDom) {
      logDom = document.createElement('div');
      bodyDom = document.createElement('div');
      logDom.id = 'app-log';
      bodyDom.className = 'log-body';
      Object.assign(logDom.style, {
        display: 'none',
        position: 'fixed',
        top: 0,
        left: 0,
        width: '80%',
        'margin-left': '10%',
        // 'padding-top': '16px',
        'z-index': '100000',
        background: 'white',
        border: '1px solid #cccccc',
        'box-shadow': '0px 4px 8px #444444',
        'font-size': '16px'
      });
      Object.assign(bodyDom.style, {
        overflow: 'auto',
        'max-height': '300px'
      });
      closeHandlerDom = document.createElement('span');
      Object.assign(closeHandlerDom.style, {
        position: 'absolute',
        top: '2px',
        right: '16px',
        cursor: 'pointer',
        'font-size': '1.5em',
        'line-height': '1em'
      });
      closeHandlerDom.addEventListener('click', () => {
        logDom.style.display = 'none';
      });
      closeHandlerDom.innerHTML = '&times;';
  
      logDom.appendChild(bodyDom);
      document.body.appendChild(logDom);
      logDom.appendChild(closeHandlerDom);
    } else {
      bodyDom = logDom.querySelector('.log-body');
    }
    logDom.style.display = 'block';
    let messageDom = document.createElement('p');
    Object.assign(messageDom.style, {
      'border-bottom': '1px solid #444444',
      'padding': '4px 8px'
    });
    messageDom.innerHTML = message;
    if (pattern === 'clear') {
      logDom.innerHTML = '';
    }
    bodyDom.appendChild(messageDom);
  };
  
  /**
   * 获取window scrollTop
   * @return {Number} scrollTop值
   */
  export const getWindowScrollTop = function () {
    return document.body.scrollTop + document.documentElement.scrollTop;
  };
  
  /**
   * 回到顶部
   */
  export const gotoWinTop = function () {
    window.scrollTo(0, 0);
  };



// WEBPACK FOOTER //
// ./src/deps/utils.js